<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.92 9.38a1 1 0 000-.76 1 1 0 00-.21-.33l-3.5-3.5a1 1 0 00-1.42 1.42L18.59 8H4a2 2 0 00-2 2v9a1 1 0 002 0v-9h14.59l-1.8 1.79a1 1 0 000 1.42 1 1 0 001.42 0l3.5-3.5a1 1 0 00.21-.33z"/></svg>